<template>
    <div class="grid grid--max-width" v-if="sliderFilterEnabled" style="position: relative;direction:ltr;">
        <div class="attraction-filters-wrapper grid grid--max-width">
            <div class="flex-container height-filter align-middle align-center">
                <label class="height-filter__label flex-none" for="height">{{heightSliderFilterText}}</label>
                <div class="flex-container height-filter__slider">
                    <slider-filter-bar v-if="getMaximumSliderValue"
                                       :sliderValue="height"
                                       :maximum="getMaximumSliderValue"
                                       :minimum="getMinimumSliderValue"
                                       :measurement="heightMeasureUnitText"
                                       :showMeasurementBeforeNumber="showMeasurementBeforeNumber" />
                    <div class="flex-container align-middle height-filter__short flex-none">
                        <span class="flex-none">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 width="11"
                                 height="32"
                                 viewBox="0 0 11 32"
                                 aria-hidden="true"
                                 focusable="false">
                                <path fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M5.5 12.7c3.04 0 5.5 2.504 5.5 5.588V20.4c0 .365-.295.66-.66.66h-.682l-1.445 5.663c-.075.292-.338.497-.64.497H3.426c-.302 0-.565-.205-.64-.497L1.342 21.06H.66c-.365 0-.66-.295-.66-.66v-2.112C0 15.204 2.46 12.7 5.5 12.7zm0 1.32c-2.306 0-4.18 1.908-4.18 4.268v1.452h.534c.302 0 .565.205.64.497L3.938 25.9h3.123l1.445-5.663c.075-.292.338-.497.64-.497h.534v-1.452c0-2.36-1.874-4.268-4.18-4.268zm0-9.24c2.066 0 3.74 1.674 3.74 3.74s-1.674 3.74-3.74 3.74-3.74-1.674-3.74-3.74S3.434 4.78 5.5 4.78zm0 1.32c-1.337 0-2.42 1.083-2.42 2.42s1.083 2.42 2.42 2.42 2.42-1.083 2.42-2.42S6.837 6.1 5.5 6.1z" />
                            </svg>
                        </span>
                        <span class="flex-none">{{formatMin}}</span>
                    </div>

                    <div class="flex-container align-middle height-filter__tall flex-none">
                        <span class="flex-none">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 width="11"
                                 height="32"
                                 viewBox="0 0 11 32"
                                 aria-hidden="true"
                                 focusable="false">
                                <path fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M5.5 8.798c3.053 0 5.5 2.664 5.5 5.919v2.2c0 .434-.352.786-.786.786h-.46L8.301 30.754c-.044.398-.381.699-.781.699H3.48c-.4 0-.737-.301-.781-.699L1.246 17.702h-.46c-.434 0-.786-.351-.786-.785v-2.2c0-3.255 2.447-5.919 5.5-5.919zm0 1.571c-2.154 0-3.929 1.932-3.929 4.348v1.414h.378c.4 0 .737.301.781.699l1.453 13.051h2.635L8.27 16.83c.044-.398.381-.699.781-.699h.378v-1.414c0-2.416-1.775-4.348-3.929-4.348zm0-9.821c2.103 0 3.786 1.8 3.786 3.994S7.603 8.536 5.5 8.536s-3.786-1.8-3.786-3.994S3.397.548 5.5.548zm0 1.571c-1.211 0-2.214 1.073-2.214 2.423S4.289 6.964 5.5 6.964s2.214-1.073 2.214-2.423S6.711 2.119 5.5 2.119z" />
                            </svg>
                        </span>
                        <span class="flex-none">{{formatMax}}</span>
                    </div>
                </div>
                <slider-filter-icon></slider-filter-icon>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import Vuex from "vuex";
    import { mapState, mapGetters } from "vuex";
    import sliderFilterBar from './sliderFilterBar.vue';
    import sliderFilterIcon from './sliderFilterIcon.vue';

    export default {
        components: {
            sliderFilterBar,
            sliderFilterIcon
        },
        methods: {
            formatHeight(n, system, format) {
                if (system == "m") {
                    if (this.showMeasurementBeforeNumber) {
                        return format + n / 100;
                    } else {
                        return n / 100 + format;
                    }
                } else if (system == "c") {
                    if (this.showMeasurementBeforeNumber) {
                        return format + n;
                    } else {
                        return n + format;
                    }
                } else {
                    var realFeet = (n * 0.3937) / 12;
                    var feet = Math.floor(realFeet);
                    var inches = Math.round((realFeet - feet) * 12);
                    return feet + "'" + inches + '"';
                }
            }
        },
        computed: {
            ...mapState("filters", [
                "sliderFilterEnabled",
                "defaultSliderValue",
                "height",
                "heightMeasureUnitText",
                "heightSliderFilterText",
                "showMeasurementBeforeNumber"
            ]),
            ...mapGetters("filters", [
                "getMinimumSliderValue",
                "getMaximumSliderValue",
                "getMeasurementType"
            ]),
            formatMin() {
                return this.formatHeight(
                    this.getMinimumSliderValue,
                    this.getMeasurementType,
                    this.heightMeasureUnitText
                );
            },
            formatMax() {
                return this.formatHeight(
                    this.getMaximumSliderValue,
                    this.getMeasurementType,
                    this.heightMeasureUnitText
                );
            }
        }
    };
</script>